
















































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import bincolumns from './bin-columns';
import ViewBin from './view-bin.vue'
class  PageBinRequest extends PageRequest{
    keyword:string;
    binType: string;
    roomCode: string;
    aisleCode: string;
    level:number=null; 
}

@Component({
    components:{ViewBin}
})
export default class Bin extends mixins(ListMixin, AbpBase){
    namespace = 'bin';
    pagerequest:PageBinRequest=new PageBinRequest();
    binTypes=[];
    rooms=[];
    aisles=[];
     get store () {
      return this.$store.state.bin;
    }
    isTenant() {
      return this.$store.state.session.tenant != null;
    }
    async getBinTypes(){
        await this.$store.dispatch({
            type:'bin/getBinTypes'
        }).then(()=>{
          this.binTypes= this.$store.state.bin.binTypes;
        });
    }
    async getRooms(){
         await this.$store.dispatch({
            type:'bin/getRooms'
        }).then(()=>{
          this.rooms = this.$store.state.bin.rooms;
        });
    }
    async getAisles(){
        await this.$store.dispatch({
            type:'bin/getAisles'
        }).then(()=>
        {
          this.aisles = this.$store.state.bin.aisles;
        });
    }
    importBins(){
        this.$router.push({path: '../grpwarehouse/import-bin'});
    }
    get list(){
      var re = this.$store.state.bin.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    columns= [
        ...bincolumns
        ]
    async created(){
        await this.getRooms();
        await this.getAisles();
        await this.getBinTypes();
    }
}
